import Paper from '@material-ui/core/Paper';
import React from 'react';
import { Component, NavigationActions } from '../../../client';
import { translate } from '../../../l10n';
import { LinkButton } from '../../ux/Buttons';

class RoutinesEmptyPlaceholder extends Component {
   constructor(props) {
      super(props);
   }

   _onAddLocationClicked = () => {
      NavigationActions.to({ to: '/app/locations' });
   };

   render() {
      const { hasLocations } = this.props;

      const canAction = hasLocations;

      return (
         <div className={'RoutinesEmptyPlaceholder'}>
            <Paper className={'info-box'} elevation={3}>
               <h2 className='heading'>{translate('routines.empty.title')}</h2>

               <div style={{ textAlign: 'center' }}>{translate('routines.empty.body')}</div>
               {!hasLocations && (
                  <p>
                     Start by
                     <LinkButton color='primary' onClick={this._onAddLocationClicked}>
                        defining locations
                     </LinkButton>
                     where the Ops can be performed
                  </p>
               )}
               {canAction && (
                  <p>
                     {translate('routines.empty.callToActionPrefix')}
                     <b> {translate('routines.empty.callToActionButtonName')} </b>
                     {translate('routines.empty.callToActionSuffix')}
                  </p>
               )}
            </Paper>
         </div>
      );
   }
}

export default RoutinesEmptyPlaceholder;
